import {
  Button,
  Flex,
  Heading,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Spinner,
  Tooltip,
  useColorModeValue,
} from '@chakra-ui/react';
import { ArrowRight, CheckCircle } from 'lucide-react';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useAuth } from '../../hooks/auth';
import SignIn from '../../pages/SignIn';
import { useFiliais } from '../../services/hooks/useFiliais';
import iflexApi from '../../services/iflexApi';
import { formatCNPJ } from '../../utils/formatCNPJ';
import { formatCPF } from '../../utils/formatCPF';
import getBuildFormUrlencodedParams from '../../utils/getBuildFormUrlencodedParams';
import LoadingFlex from '../shared/LoadingFlex';
import Table from '../shared/Table';

interface IFiliaisModal {
  aberto: boolean;
  fechar: any;
}

const FiliaisModal: React.FC<IFiliaisModal> = ({ aberto, fechar }) => {
  // estilos
  const bg = useColorModeValue('white', 'gray.800');
  const color = useColorModeValue('#2D3748', 'white');
  const spinnerColor = useColorModeValue('teal.200', 'blue.600');

  // estados
  const [enviando, setEnviando] = useState(0);

  // dados
  const { data } = useFiliais();
  const [filiais, setFiliais] = useState(data?.filiais);
  const { setData, user } = useAuth();

  useEffect(() => {
    setFiliais(data?.filiais);
  }, [data]);

  const handleSelecionaFilial = useCallback(
    async (filial_id: string) => {
      if (enviando !== 0) return;
      setEnviando(Number(filial_id));
      try {
        return;
        const data = getBuildFormUrlencodedParams({
          action: 'selecionaFilial',
          controller: 'Filial',
          id_fil: filial_id,
        });

        const response = await iflexApi.post('', data);
        if (response.data.success) {
          const filialSelecionada = `${user.empresa_id}|${filial_id}`;

          const salvarFilial = getBuildFormUrlencodedParams({
            action: 'setDatabase',
            controller: 'Integrations/FilialSessionGeneric',
            empresaFilialId: filialSelecionada,
          });

          const response = await iflexApi.post('', salvarFilial);
          if (response.data.success) {
            const formatedUser = {
              id: user.id,
              name: user.name,
              empresa_id: user.empresa_id,
              filial_id,
            };

            localStorage.setItem('@okton:user', JSON.stringify(formatedUser));
            const DIRECIONADORES_STORAGE_KEY = 'cached_direcionadores';
            localStorage.removeItem(DIRECIONADORES_STORAGE_KEY);

            setData(prev => ({
              ...prev,
              user: formatedUser,
            }));

            window.location.reload();
          }
        }
      } catch (error) {
        //
      } finally {
        setEnviando(0);
      }
    },
    [enviando, user, setData],
  );

  const getData = () => {
    const dados = filiais;
    const rows: any[] = [];
    dados?.forEach(item => {
      rows.push({
        codigo: item.id_fil,
        nome: item.descricao,
        cpf_cnpj: item.cpf_fil
          ? formatCPF(item.cpf_fil)
          : formatCNPJ(item.cnpj_fil),
      });
    });

    return rows;
  };

  const coluna = useMemo(
    () => [
      {
        Header: 'CÓDIGO',
        accessor: 'codigo',
      },
      {
        Header: 'NOME',
        accessor: 'nome',
      },
      {
        Header: 'CPF/CNPJ',
        accessor: 'cpf_cnpj',
      },
      {
        Header: 'AÇÕES',
        accessor: '_',
        Cell: ({ row }: { row: any }) => {
          return (
            <Flex w="min-content">
              <Tooltip
                label={
                  row.original.codigo === user.filial_id
                    ? 'Filial Atual'
                    : 'Trocar Filial'
                }
              >
                <Flex>
                  <Button
                    colorScheme="green"
                    onClick={() => handleSelecionaFilial(row.original.codigo)}
                    disabled={row.original.codigo === user.filial_id}
                  >
                    {enviando === Number(row.original.codigo) ? (
                      <Spinner
                        color={spinnerColor}
                        speed="0.6s"
                        borderWidth={3}
                      />
                    ) : row.original.codigo === user.filial_id ? (
                      <CheckCircle />
                    ) : (
                      <ArrowRight />
                    )}
                  </Button>
                </Flex>
              </Tooltip>
            </Flex>
          );
        },
      },
    ],
    [enviando, handleSelecionaFilial],
  );

  return (
    <Modal onClose={fechar} isOpen={aberto} size="auto">
      <ModalOverlay />
      <ModalContent
        p="4"
        bg={bg}
        borderWidth="1px"
        rounded="2xl"
        w="40%"
        mx="50px"
      >
        <ModalCloseButton color={color} />
        <Heading fontWeight="medium" fontSize="2xl">
          Trocar de Filial
        </Heading>
        <Table columns={coluna} data={getData()} hideFooter />
      </ModalContent>
    </Modal>
  );
};

export default FiliaisModal;
